// Roles allowed to see billing (CPT codes) and call the /clinic/biller CPT APIs
export const BILLER_ROLES = ['biller', 'billingAdmin'];

export const isBillerRole = userType => BILLER_ROLES.includes(userType);
